import cn from "classnames"
import React from "react"
import env from "@/common/env"

const NativeRadio: React.FC<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = props => <input type="radio" {...props} />

const RadioButton: React.FC<
  React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = props => (
  <div
    className={cn("radio-button", { checked: props.checked, disabled: props.disabled })}
    onClick={() => props.onChange && props.onChange({} as React.ChangeEvent<HTMLInputElement>)}
  >
    <input type="radio" {...props} />
    <div className="overlay" />
  </div>
)

export default env.TEST ? NativeRadio : RadioButton
